import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

const slotPillClass =
  'border-border bg-muted text-foreground hover:bg-muted/80';

export interface PlanogramSlotBadgeProps {
  label: string;
  muted?: boolean;
  className?: string;
}

export function PlanogramSlotBadge({ label, muted = false, className }: PlanogramSlotBadgeProps) {
  return (
    <Badge
      variant="outline"
      className={cn(
        'font-mono text-xs tabular-nums font-medium',
        slotPillClass,
        muted && 'text-muted-foreground',
        className
      )}
    >
      {label}
    </Badge>
  );
}
